import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, LogIn } from "lucide-react";
import { Logo } from "@/components/Logo";
import PublicGrid from "@/components/PublicGrid";
import { useAuth } from "@/context/AuthContext";

export default function Home() {
  const { user } = useAuth();
  return (
    <div className="min-h-screen relative z-[1] bg-transparent text-[#F5F5F7]" data-testid="home-page">
      <header className="sticky top-0 z-30 bg-[#0B1013]/60 backdrop-blur-xl border-b border-white/5">
        <div className="max-w-[1800px] mx-auto px-5 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5" data-testid="home-logo"><Logo size={32} showName={false} /><span className="font-heading font-bold text-lg tracking-tight">Ai Xtudio</span></Link>
          {user
            ? <Link to="/projects" className="ax-generate h-10 px-5 text-sm" data-testid="home-open-studio">Open Studio <ArrowRight className="w-4 h-4" /></Link>
            : <Link to="/login" className="ax-generate h-10 px-5 text-sm" data-testid="home-sign-in"><LogIn className="w-4 h-4" />Sign in</Link>}
        </div>
      </header>
      <section className="max-w-[1800px] mx-auto px-5 pt-12 pb-8">
        <div className="ax-pill mb-4">Community showcase</div>
        <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight max-w-3xl leading-[1.05]">
          Made in <span className="ax-gradient-text">Ai Xtudio.</span>
        </h1>
        <p className="text-base md:text-lg text-zinc-400 mt-4 max-w-xl">Images and films our creators chose to share. Tap any piece to see the prompt and the BFX model behind it.</p>
      </section>
      <main className="max-w-[1800px] mx-auto px-5 pb-20">
        <PublicGrid emptyHint="Creators can publish any finished result from the studio — it will show up here." />
      </main>
    </div>
  );
}
